import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AsyncStatus } from "../../models/async-status";
import { getScheduledDistributions } from "../../services/distributions";
import { ScheduledDistributionEvent } from "../../models/distributions/scheduled-distribution-event";

export const fetchScheduledDistributionEvents = createAsyncThunk(
  "fetch-scheduled-distribution-events",
  async (
    { planId, empId, role }: { planId: number; empId: number; role: string },
    thunkApi
  ) => {
    return getScheduledDistributions({ planId, empId, role });
  }
);

type State = {
  scheduledDistributionEvents: ScheduledDistributionEvent[];
  status: AsyncStatus;
};

const initialState: State = {
  scheduledDistributionEvents: [],
  status: AsyncStatus.not_fetched,
};

const scheduledDistributionEventSlice = createSlice({
  name: "scheduledDistributionEvents",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchScheduledDistributionEvents.pending,
      (state, action) => {
        return { ...state, status: AsyncStatus.loading };
      }
    );
    builder.addCase(
      fetchScheduledDistributionEvents.fulfilled,
      (
        state,
        action: { payload: ScheduledDistributionEvent[]; type: string }
      ) => {
        const scheduledDistributionEvents = action.payload;

        return {
          ...state,
          scheduledDistributionEvents,
          status: AsyncStatus.done,
        };
      }
    );
    builder.addCase(
      fetchScheduledDistributionEvents.rejected,
      (state, action) => {
        return { ...state, status: AsyncStatus.error };
      }
    );
    builder.addDefaultCase((state, action) => state);
  },
});

export default scheduledDistributionEventSlice.reducer;
